module.exports = __webpack_public_path__ + "images/emoji/ghost.133ecad356e47330052f.png";